module.exports = __webpack_public_path__ + "static/media/ETH-icon.b2dc0369.svg";